module.exports = __webpack_public_path__ + "media/images/iconClose__inactive--dark-468b5e28343efc0179c589618d746287.png";